import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-188b01cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Edit path", -1))
const _hoisted_2 = { class: "toggle-check-container margin-b-standard" }
const _hoisted_3 = { class: "toggle-check" }
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "data-on-text": "Long path name",
  "data-off-text": "Short path name"
}, null, -1))
const _hoisted_6 = { class: "margin-b-standard" }
const _hoisted_7 = { class: "path-item" }
const _hoisted_8 = ["selected", "value"]
const _hoisted_9 = ["value", "selected"]
const _hoisted_10 = { class: "margin-b-standard" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]

import ContentLocationPath from "@/components/right-sidebars/content-sidebar/content-location/ContentLocationPath.vue";
import { computed, onMounted, PropType, ref } from "vue";
import csHelper from "@/utils/product/content-structure-helpers";
import { GeneratedContentStructure } from "@/models/content-structure.model";
import { AssetLocation } from "@/models/assets.model";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";
import { PathToDisplay } from "@/models/product-section.model";
import { useUIContentStore } from "@/stores/ui-content.store";
import { useContentStore } from "@/stores/content.store";
import { ProductItem } from "@/models/product.model";
import { showToast } from "@/services/notification-manager";
import { SECTION } from "@/constants/assets.constant";
import ErrorMessage from "@/components/ErrorMessage.vue";
import Popup from "@/components/Popup.vue";
import {
  getPossiblePaths,
  getSortedPathsForDisplay
} from "@/utils/product/get-path-to-section";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditContentPath',
  props: {
  product: {
    required: true,
    type: Object as PropType<ProductItem>
  },
  structure: {
    required: true,
    type: Object as PropType<GeneratedContentStructure>
  },
  path: {
    required: true,
    type: Array as PropType<AssetLocation[]>
  },
  sectionName: {
    required: true,
    type: String
  },
  sectionId: {
    required: true,
    type: Number
  },
  sectionIconId: {
    required: true,
    type: Number
  },
  sectionExternalId: {
    required: true,
    type: String
  }
},
  setup(__props) {

const uiContentStore = useUIContentStore();
const contentStore = useContentStore();

const props = __props;

const oldParentId = ref<number | null>(null);
const newParentId = ref<number | null>(null);
const currentPath = computed<AssetLocation[]>(() => {
  return !!props.structure.rootSection
    ? csHelper.getPathToSectionWithIds(
        props.structure.rootSection,
        props.sectionId
      )
    : [];
});
const setParentIds = (): void => {
  if (props.structure.rootSection) {
    if (currentPath.value.length > 0) {
      oldParentId.value = currentPath.value[currentPath.value.length - 1].id;
      newParentId.value = oldParentId.value;
    } else {
      oldParentId.value = props.structure.rootSection.id;
      newParentId.value = oldParentId.value;
    }
  }
};
onMounted(() => {
  setParentIds();
});

const isSubmitting = ref<boolean>(false);
const isLongPathNameEnabled = ref<boolean>(true);
const isSelectVisible = computed<boolean>(() => {
  return (
    !!newParentId.value &&
    !!props.structure.rootSection &&
    newParentId.value !== props.structure.rootSection.id
  );
});
const isSaveBtnDisabled = computed<boolean>(() => {
  return (
    newParentId.value === oldParentId.value ||
    newParentId.value === 0 ||
    newParentId.value === props.sectionId ||
    isSubmitting.value
  );
});

const possiblePaths = computed<AssetLocation[][]>(() => {
  const paths = getPossiblePaths(
    props.product.sections,
    props.structure.rootSection
  );
  return paths.filter((path: AssetLocation[]): boolean => {
    // remove all paths to child sections of the current section
    return !path.some((pathItem: AssetLocation): boolean => {
      return pathItem.id === props.sectionId;
    });
  });
});
const sortedPathsToDisplay = computed<PathToDisplay[]>(() => {
  return getSortedPathsForDisplay(possiblePaths.value, props.product.name);
});

const newPath = computed<AssetLocation[] | undefined>(() => {
  if (newParentId.value !== oldParentId.value) {
    if (
      props.structure.rootSection &&
      newParentId.value === props.structure.rootSection.id
    ) {
      return [];
    }
    return possiblePaths.value.find(
      (possiblePath: AssetLocation[]): boolean => {
        return (
          !!newParentId.value &&
          possiblePath[possiblePath.length - 1].id === newParentId.value
        );
      }
    );
  }
  return props.path;
});

const serverError = ref<string>("");
const updatePath = () => {
  if (newParentId.value) {
    isSubmitting.value = true;
    const payload = {
      productIds: [props.product.id],
      sections: [
        {
          id: props.sectionId,
          new_parent_section_id: newParentId.value
        }
      ]
    };
    contentStore
      .upsertSections(payload)
      .then(response => {
        if (response.status === 200) {
          showToast({
            message: SECTION.SUCCESS.internalPath,
            type: "is-success"
          });
          uiContentStore.closeEditContentPathModal();
        }
      })
      .catch(error => {
        serverError.value = error.message;
      })
      .finally(() => {
        isSubmitting.value = false;
      });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    width: 1300,
    "modal-card-classes": ['edit-path-card'],
    onClosePopup: _unref(uiContentStore).closeEditContentPathModal
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "aria-label": "edit",
            value: isLongPathNameEnabled.value,
            "data-testing": "toggle-edit-mode",
            class: "editable",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isLongPathNameEnabled).value = $event))
          }, null, 8, _hoisted_4), [
            [_vModelCheckbox, isLongPathNameEnabled.value]
          ]),
          _hoisted_5
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createVNode(RightSidebarTitle, { title: 'Select path' }),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newParentId).value = $event))
            }, [
              _createElementVNode("option", {
                selected: newParentId.value === __props.structure.rootSection.id,
                value: __props.structure.rootSection.id
              }, _toDisplayString(__props.product.name), 9, _hoisted_8),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedPathsToDisplay.value, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item.lastChildSectionId,
                  value: item.lastChildSectionId,
                  selected: item.lastChildSectionId === newParentId.value
                }, _toDisplayString(item.pathString), 9, _hoisted_9))
              }), 128))
            ], 512), [
              [_vModelSelect, newParentId.value]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(RightSidebarTitle, { title: 'Old path' }),
        _createVNode(ContentLocationPath, {
          product: __props.product,
          path: __props.path,
          "section-name": __props.sectionName,
          "section-id": __props.sectionId,
          "section-icon-id": __props.sectionIconId,
          "section-external-id": __props.sectionExternalId,
          "is-clickable": false,
          "is-long-path-name-enabled": isLongPathNameEnabled.value
        }, null, 8, ["product", "path", "section-name", "section-id", "section-icon-id", "section-external-id", "is-long-path-name-enabled"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(RightSidebarTitle, { title: 'New path' }),
        _createVNode(ContentLocationPath, {
          product: __props.product,
          path: newPath.value,
          "section-name": __props.sectionName,
          "section-id": __props.sectionId,
          "section-icon-id": __props.sectionIconId,
          "section-external-id": __props.sectionExternalId,
          "is-clickable": false,
          "is-long-path-name-enabled": isLongPathNameEnabled.value
        }, null, 8, ["product", "path", "section-name", "section-id", "section-icon-id", "section-external-id", "is-long-path-name-enabled"])
      ]),
      (serverError.value)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            message: serverError.value
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        disabled: isSubmitting.value,
        class: "btn-2",
        type: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(uiContentStore).closeEditContentPathModal && _unref(uiContentStore).closeEditContentPathModal(...args)))
      }, " Cancel ", 8, _hoisted_11),
      _createElementVNode("button", {
        class: "btn-1",
        type: "button",
        onClick: updatePath,
        disabled: isSaveBtnDisabled.value
      }, " Save ", 8, _hoisted_12)
    ]),
    _: 1
  }, 8, ["onClosePopup"]))
}
}

})